import { BaseEnum } from "./baseEnum";

const listApprovalScopeActionTypeEnum: Array<ApprovalScopeActionType> = [];

export class ApprovalScopeActionType extends BaseEnum {
  static NONE = new ApprovalScopeActionType(0, "NONE", "Nenhum");
  static APPLY_INCREASE_ON_WORKFORCE_PLAN = new ApprovalScopeActionType(
    1,
    "APPLY_INCREASE_ON_WORKFORCE_PLAN",
    "Aplicar aumento de quandro"
  );
  static EDIT_EXPECTED_DISMISSAL_DATE = new ApprovalScopeActionType(
    2,
    "EDIT_EXPECTED_DISMISSAL_DATE",
    "Editar data prevista para o desligamento"
  );
  static SHOW_OPTION_TO_APPROVE_AND_FINISH_TRAINING =
    new ApprovalScopeActionType(
      3,
      "SHOW_OPTION_TO_APPROVE_AND_FINISH_TRAINING",
      "Exibir opção para aprovar e informar data fim do treino do colaborador"
    );
  static SHOW_FIELD_TO_INDICATE_START_TRAINING = new ApprovalScopeActionType(
    4,
    "SHOW_FIELD_TO_INDICATE_START_TRAINING",
    "Exibir campo para indicar início do treinamento do colaborador"
  );
  static SELECT_JUSTIFICATION_AND_UPDATE_NOTE = new ApprovalScopeActionType(
    5,
    "SELECT_JUSTIFICATION_AND_UPDATE_NOTE",
    "Selecionar justificativa e atualizar observação"
  );
  static SHOW_FIELDS_TO_APPROVE_NEW_JOBTITLE_TRAINED =
    new ApprovalScopeActionType(
      6,
      "SHOW_FIELDS_TO_APPROVE_NEW_JOBTITLE_TRAINED",
      "Exibir os campos para mudança de função"
    );
  static STOP_AUTOMATIC_APPROVAL_IN_RUN = new ApprovalScopeActionType(
    7,
    "STOP_AUTOMATIC_APPROVAL_IN_RUN",
    "Interromper aprovação automática em execução"
  );
  static CHECK_THERE_CHANGE_IN_COST_CENTER = new ApprovalScopeActionType(
    8,
    "CHECK_THERE_CHANGE_IN_COST_CENTER",
    "Verificar se existe mudança de centro de custo"
  );
  static ERP_INTEGRATION = new ApprovalScopeActionType(
    9,
    "ERP_INTEGRATION",
    "Integração com ERP"
  );
  static DOCUMENT_GENERATOR_INTEGRATION = new ApprovalScopeActionType(
    10,
    "DOCUMENT_GENERATOR_INTEGRATION",
    "Integração com Gerador de Documentos"
  );
  static SHOW_FIELD_TO_APPROVE_UNHEALTHINESS = new ApprovalScopeActionType(
    11,
    "SHOW_FIELD_TO_APPROVE_UNHEALTHINESS",
    "Exibir campo para aprovar insalubridade"
  );
  static CREATE_RECRUITMENT_POSITION = new ApprovalScopeActionType(
    12,
    "CREATE_RECRUITMENT_POSITION",
    "Criar posição no Recrutamento e Seleção"
  );

  constructor(public id: number, public value: string, public label: string) {
    super(id, value, label);

    listApprovalScopeActionTypeEnum.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listApprovalScopeActionTypeEnum;
  }

  public static getWfpActionTypes(): ApprovalScopeActionType[] {
    return listApprovalScopeActionTypeEnum.filter(action => action.id > 0);
  }
}
